import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93c8c8dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['tw-flex cell-name tw-w-max'])
}
const _hoisted_2 = { class: "name tw-flex tw-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "information tw-flex tw-flex-none tw-flex-col tw-mr-3" }
const _hoisted_5 = { class: "name tw-font-semibold" }
const _hoisted_6 = { class: "email tw-text-xs grey-color" }

import { IMemberInfo } from "@/interfaces/members/IMember";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cellTableInfo',
  props: {
  classValue: { type: String, default: "" },
  value: { type: Object as PropType<IMemberInfo>, required: true },
  isCurrentUser: { type: Boolean, default: false },
  colorName: { type: String, default: "#231f20" },
  colorEmail: { type: String, default: "#878787" },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "70a3e9f5": (__props.colorName),
  "b9406d1c": (__props.colorEmail)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.value.imgSrc)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.value.imgSrc,
            alt: "person_random"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.value.nameText) + " " + _toDisplayString(__props.isCurrentUser ? "(You)" : ""), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.value.email), 1)
      ])
    ])
  ]))
}
}

})